import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Min } from "../../types/Min";
import { Regex } from "../../types/Regex";

@Component({
  selector: "app-prefix-uu3",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-uu3.component.html",
  styleUrl: "./prefix-uu3.component.less",
})
export class PrefixUu3Component extends PrefixComponent<string> {
  public min: Min;
  public regex: Regex;
  public commas: number;

  public constructor() {
    super({
      defaultValue: "0",
      updateOn: "blur",
    });
    this.min = 0.0;
    this.regex = "UU3";
    this.commas = 2;
    this.characters = ALLOWED_CHARACTERS["uu3"];
  }
}
